<template>
  <div>
    <Alert type="warning">
      <div class="flex items-center restriction-box">
        <img src="@/assets/orderTest/info_icon_yellow_24px.svg" class="pl-3 px-2" alt="error outline">
        <div class="flex items-center">
          <span>
            {{ $t('OrderPage["{ count }Countries are in shipping exception list."]', { count: countryRestrictList.length }) }}
          </span>
          <a
            id="country-restrict-link" 
            @click="isShowCountryRestriction = true"
          >
            <u class="pl-1">{{ $t('OrderPage["Check the country restrictions here."]') }}</u>
          </a>
        </div>
      </div>
    </Alert>
    <CountryRestrictionDialog
      :is-show-country-restriction="isShowCountryRestriction"
      @close="isShowCountryRestriction=false"
    />
  </div>
</template>

<script>
import Alert from "../components/Alert.vue";
import CountryRestrictionDialog from "./CountryRestrictionDialog.vue";
import { countryRestrictList } from "@/utils/va-order-test/index.js";

export default {
  components: {
    Alert,
    CountryRestrictionDialog
  },

  props: {
    isNarrow: {
      type: Boolean,
      default: false,
    }
  },  

  data() {
    return {
      isShowCountryRestriction: false,
      countryRestrictList: countryRestrictList,
    }
  }
}
</script>

<style scoped>
.restriction-box {
  padding-bottom: 9px;
  padding-top: 9px;
}
#country-restrict-link {
  cursor: pointer;
  
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #E0961E;
}
.restriction-text {
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.4px;
  text-align: left;
  color: #E0961E;
}
</style>